import { Navigate, useSearchParams } from "react-router-dom";

/** Legacy redirect: /pricing/payment/result?outcome=success|failure */
export default function PaymentResultPage() {
    const [searchParams] = useSearchParams();
    const outcome = searchParams.get("outcome");
    const target =
        outcome === "failure"
            ? "/pricing/payment/failure"
            : "/pricing/payment/success";
    const query = searchParams.toString();

    return <Navigate to={query ? `${target}?${query}` : target} replace />;
}
